'use strict';

var globalisation = require('../../utilities/globalisation');
//jscs:enable requireMultipleVarDecl

module.exports = function(Handlebars) {
  function GlobalisationHelpers() {
    this.registerHelpers();
  }

  GlobalisationHelpers.prototype.registerHelpers = function() {
    Handlebars.registerHelper('translate', this.translate);
    Handlebars.registerHelper('formatCurrency', this.formatCurrency);
    Handlebars.registerHelper('formatNumber', this.formatNumber);
    Handlebars.registerHelper('formatDate', this.formatDate);
  };

  /**
   * Format currency
   * Will get the current currencyIso from a cookie set based on the user's locale.
   * This then calls formatting methods supplied as part of jQuery globalise
   */
  GlobalisationHelpers.prototype.formatCurrency = function(value) {
    var result = globalisation.formatCurrency(value);
    return new Handlebars.SafeString(result);
  };

  /**
   * Format number
   * Based on locale
   */
  GlobalisationHelpers.prototype.formatNumber = function(value) {
    var result = globalisation.formatNumber(value);
    return new Handlebars.SafeString(result);
  };

  /**
   * Translate helper
   Uses jQuery Globalise library (https://github.com/jquery/globalize)

   The keys file will get loaded in a script file before any other js ensuring the translations are
   always available before any templates are rendered.

   The key formatting in this library matches what we have done for Arrow on the backend. the caveat is that we have to have a number
   of fairly large files in FE as part of the bundle. These are located in /js/third-party/ and are excluded from the FE code-check task for now.

   Documentation and examples for Arrow implementation can be found in the front end site here: http://localhost:3000/dev -views/handlebars-translations.html

   The logic for the translation action (pluraliseAndTranslate) has been moved to the globalisation file as methods housed there can be used elswhere in the site and not only
   with helpers.

   The syntax in a template is as follows:

   SIMPLE STRING REPLACE
   {{translate "domain" keyName" .}}

   Where translate is this helper.

   "domain" is the domain level the the translate mapping file provided. eg shoppingCart in this example:
   {
     "shoppingCart": {
       "keyName": "Welcome to your basket"
     }
   }
   "keyName" is the key to match to the correct key in the mapping file eg:

   "keyname" : "Hi {userName}, you have been busy shopping!"

   "." is the current context. This should be used if the parameter to be translated is at the base level of the data object passed to the template.

   {
     "userName": "Mark Smith"
   }

   THIS HELPER WILL NOT WORK WITH A SINGLE VARIABLE PASSED TO IT ALA NORMAL HANDLEBARS.
   This is because we have to pass the model with the parameters correctly named from the server straight into the helper to map against each key phrases parameters.

   Data needs to be transformed at the parsing stage in any view as the helper needs a ready formatted object
   to be passed to it on order for multi item mappings to work correctly.

   In the example this comes back from the server on model.fetch:
   {
     header: "Welcome to your basket",
     user: {
       name: "Mark Smith"
     },
     price: "10.99",
     basket: {
       count: 0
     },
     wishlist: {
       count: 10
     }
   }

   and it needs to be reformatted to so that related items can be passed into the helper to match the mapping. So the key map:

   "key1": "Hey {userName}, you have {basketCount, plural, zero{no items in your basket} =0{no items in your basket} one{one item in your basket} two{two items in your basket} few{a few items in your basket} many{many items in your basket} =42{forty two items in your basket} other{many items in your basket}}"

   Requires 'user.name' and 'basket.count' to be passed in as a single object like:

   userAndCount : {
      name: user.name
      basketCount: basket.count
    }

   so that the helper can process with:

   {{translate "domain" "key1" userAndCount}}

   ========================================================================== */
  GlobalisationHelpers.prototype.translate = function(domain, key, item) {
    var result = globalisation.pluraliseAndTranslate(domain, key, item);
    return new Handlebars.SafeString(result);
  };

  GlobalisationHelpers.prototype.formatDate = function(item) {
    var d = new Date(item);
    var parts = d.toDateString().split(' ');
    var result = parts[2] + ' ' + parts[1];
    return new Handlebars.SafeString(result);
  };

  return new GlobalisationHelpers();
};



// WEBPACK FOOTER //
// ./assets/js/handlebars-helpers/globalisationHelpers.js